
export const styles = {
  container: {
    backgroundColor: 'animate-glass-morph bg-gradient-to-br from-white/70 via-white/60 to-purple-50/50 bg-size-200 animate-gradient-slow',
    minHeight: '250px',
    backdropFilter: 'backdrop-blur-lg',
    position: 'relative',
    overflow: 'hidden'
  },
  header: {
    background: 'animate-glass-shine bg-gradient-to-r from-purple-600 to-purple-700 bg-opacity-90',
    textColor: 'text-white font-medium',
    border: 'border-b border-white border-opacity-20',
    backdropFilter: 'backdrop-blur-xl',
    position: 'relative',
    zIndex: '10',
    padding: 'py-6',
    height: 'h-24',
    animation: 'glass-header-shine 3s ease-in-out infinite'
  },
  avatar: {
    background: 'animate-glass-pulse bg-white bg-opacity-50 backdrop-blur',
            text: 'text-purple-700',
    border: 'border-2 border-purple-500',
    animation: 'glass-avatar-float 6s ease-in-out infinite',
    boxShadow: 'shadow-lg shadow-purple-500/20',
    position: 'relative',
    zIndex: '10',
    shape: 'rounded-full aspect-square overflow-hidden'
  },
  messages: {
    bot: {
      background: 'animate-glass-fade bg-white/90 backdrop-blur transform transition-all duration-300 hover:translate-y-[-2px] hover:shadow-lg relative z-10',
      text: 'text-gray-800 font-medium',
      border: 'border border-white border-opacity-30',
      animation: 'glass-message-appear 0.5s ease-out forwards'
    },
    user: {
      background: 'animate-glass-fade bg-white/90 backdrop-blur transform transition-all duration-300 hover:translate-y-[-2px] hover:shadow-lg relative z-10',
      text: 'text-gray-800 font-medium',
      border: 'border border-purple-300 border-opacity-30',
      animation: 'glass-message-appear 0.5s ease-out forwards'
    }
  },
  typingIndicator: {
    container: 'animate-glass-ripple bg-white/90 backdrop-blur relative z-10',
    dots: 'bg-purple-600',
    animation: 'glass-typing-bounce 1.4s infinite ease-in-out'
  },
  footer: {
    text: 'text-gray-700 font-medium',
    link: 'text-purple-600 hover:text-purple-700 font-medium hover:underline',
    background: 'animate-glass-wave bg-white/90 backdrop-blur-md relative z-10',
    border: 'border-t border-white border-opacity-20'
  },
  animations: {
    '@keyframes glass-morph': {
      '0%, 100%': {
        backgroundPosition: '0% 50%',
        backdropFilter: 'blur(10px) brightness(1)',
        opacity: 0.7
      },
      '50%': {
        backgroundPosition: '100% 50%',
        backdropFilter: 'blur(12px) brightness(1.1)',
        opacity: 0.8
      }
    },
    '@keyframes glass-header-shine': {
      '0%': {
        backgroundPosition: '200% center',
        opacity: 0.9,
        backdropFilter: 'blur(10px)',
        transform: 'translateY(0)'
      },
      '50%': {
        opacity: 1,
        backdropFilter: 'blur(12px)',
        transform: 'translateY(-2px)'
      },
      '100%': {
        backgroundPosition: '-200% center',
        opacity: 0.9,
        backdropFilter: 'blur(10px)',
        transform: 'translateY(0)'
      }
    },
    '@keyframes glass-float': {
      '0%, 100%': {
        transform: 'translateY(0) rotate(0deg)',
        opacity: 0.7
      },
      '50%': {
        transform: 'translateY(-10px) rotate(5deg)',
        opacity: 1
      }
    },
    '@keyframes glass-shine': {
      '0%': {
        backgroundPosition: '200% center',
        opacity: 0.9,
        backdropFilter: 'blur(10px)'
      },
      '50%': {
        opacity: 1,
        backdropFilter: 'blur(12px)'
      },
      '100%': {
        backgroundPosition: '-200% center',
        opacity: 0.9,
        backdropFilter: 'blur(10px)'
      }
    },
    '@keyframes glass-pulse': {
      '0%, 100%': {
        transform: 'scale(1)',
        backdropFilter: 'blur(8px)',
        backgroundColor: 'rgba(255, 255, 255, 0.2)'
      },
      '50%': {
        transform: 'scale(1.02)',
        backdropFilter: 'blur(10px)',
        backgroundColor: 'rgba(255, 255, 255, 0.3)'
      }
    },
    '@keyframes glass-fade': {
      '0%': {
        opacity: 0,
        backdropFilter: 'blur(5px)',
        backgroundColor: 'rgba(255, 255, 255, 0.5)'
      },
      '100%': {
        opacity: 1,
        backdropFilter: 'blur(10px)',
        backgroundColor: 'rgba(255, 255, 255, 0.7)'
      }
    },
    '@keyframes glass-slide': {
      '0%': {
        transform: 'translateX(20px)',
        opacity: 0,
        backdropFilter: 'blur(5px)',
        backgroundColor: 'rgba(139, 92, 246, 0.5)'
      },
      '100%': {
        transform: 'translateX(0)',
        opacity: 1,
        backdropFilter: 'blur(10px)',
        backgroundColor: 'rgba(139, 92, 246, 0.7)'
      }
    },
    '@keyframes glass-ripple': {
      '0%': {
        boxShadow: '0 0 0 0 rgba(255, 255, 255, 0.4)',
        backdropFilter: 'blur(8px)'
      },
      '70%': {
        boxShadow: '0 0 0 10px rgba(255, 255, 255, 0)',
        backdropFilter: 'blur(10px)'
      },
      '100%': {
        boxShadow: '0 0 0 0 rgba(255, 255, 255, 0)',
        backdropFilter: 'blur(8px)'
      }
    },
    '@keyframes glass-wave': {
      '0%, 100%': {
        backgroundPosition: '0% 50%',
        backdropFilter: 'blur(8px)',
        backgroundColor: 'rgba(255, 255, 255, 0.5)'
      },
      '50%': {
        backgroundPosition: '100% 50%',
        backdropFilter: 'blur(10px)',
        backgroundColor: 'rgba(255, 255, 255, 0.6)'
      }
    }
  },
  effects: {
    glassMorphism: {
      base: 'backdrop-filter backdrop-blur-lg bg-opacity-70',
      hover: 'hover:bg-opacity-80 hover:backdrop-blur-xl transition-all duration-300',
      active: 'active:bg-opacity-90 active:backdrop-blur-2xl',
      border: 'border border-white border-opacity-20'
    },
    shine: {
      base: 'before:absolute before:inset-0 before:bg-gradient-to-r before:from-transparent before:via-white before:to-transparent before:opacity-0 before:transition-opacity hover:before:opacity-20',
      animation: 'animate-shine'
    }
  },
  decorations: {
    floatingElements: {
      position: 'absolute',
      animation: 'glass-float 4s ease-in-out infinite',
      opacity: 0.7,
      zIndex: 1,
      filter: 'blur(1px)',
      mixBlendMode: 'overlay'
    }
  }
}; 